import * as actions from './actions';
import sendGoogleAnalyticsEvent from '../../utils/tracking/googleAnalytics';
import * as googleAnalyticsEvents from '../../utils/tracking/googleAnalytics';
import apiTracking from '../../utils/tracking/apiTracking';

const amountSubmittedActions = [];
const eventMappings = {};
eventMappings[actions.SELECT_AMOUNT] = [trackDonationAmountSelected];
eventMappings[actions.DONATION_GO_BACK_TO_AMOUNT] = [trackCancelAction];
eventMappings[actions.DONATION_SUCCESS] = [trackCompleteAction];
eventMappings[actions.DONATION_SUBMITTING] = [trackSubmitAction];

export default function trackDonation(type, state) {
    const eventTrackers = eventMappings[type];
    if (eventTrackers != null) {
        eventTrackers.map(f => f(state));
    }
}

function trackDonationAmountSelected(state) {
    const actionId = state.widget.activeAction.id;

    if (amountSubmittedActions.find(id => id === actionId)) return;
    amountSubmittedActions.push(actionId);

    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_DONATION_AMOUNT_SELECTED, {
        ...state.widget,
        action: state.widget.activeAction,
        amount: state.donation.selectedAmount
    });
}

function trackCancelAction(state) {
    const actionCancelTime = state.donation.cancelTime;

    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_CANCELED, {
        ...state.widget,
        action: state.widget.activeAction,
        actionCancelTime: actionCancelTime
    });

    apiTracking.trackCancelAction(state, actionCancelTime);
}

function trackCompleteAction(state) {
    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_COMPLETED, {
        ...state.widget,
        action: state.widget.activeAction,
        amount: state.donation.selectedAmount,
        actionCompleteTime: state.donation.actionCompleteTime
    });
}

function trackSubmitAction(state) {
    if (state.donation.isSubmitting) {
        sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_DONATION_PAYMENT_SUBMITED, {
            ...state.widget,
            action: state.widget.activeAction,
            amount: state.donation.selectedAmount
        });
    }
}



// WEBPACK FOOTER //
// ./src/containers/Donation/tracking.js